import React from 'react';
import { NetworkConfig } from '../config/networks';
import './PolicyDescription.css';

interface PolicyDescriptionProps {
  currentNetwork?: NetworkConfig;
  contractAddress?: string;
}

const PolicyDescription: React.FC<PolicyDescriptionProps> = ({ currentNetwork, contractAddress }) => {
  return (
    <div className="policy-section">
      <div className="policy-header">
        <h3>Policy</h3>
      </div>
      <div className="policy-content">
        <p className="policy-description">
          Transactions made on{' '}
          {currentNetwork && contractAddress ? (
            <a 
              href={`${currentNetwork.blockExplorer}/address/${contractAddress}`}
              target="_blank"
              rel="noopener noreferrer"
              className="escrow-link"
            >
              this DAO
            </a>
          ) : (
            'this DAO'
          )}
          {' '}are subject to verifications through Trustline compliance system.
        </p>
        <div className="policy-items">
          <div className="policy-item">
            <div className="policy-item-header">
              <span className="policy-name">Sanctions List</span>
              <div className="policy-scopes">
                <span className="policy-scope">Create Proposal</span>
                <span className="policy-scope">Vote</span>
              </div>
            </div>
            <span className="policy-desc">OFAC verification</span>
          </div>
          <div className="policy-item">
            <div className="policy-item-header">
              <span className="policy-name">Proxy Check</span>
              <div className="policy-scopes">
              <span className="policy-scope">Create Proposal</span>
                <span className="policy-scope">Vote</span>
              </div>
            </div>
            <span className="policy-desc">No Proxy/VPN/Tor allowed</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolicyDescription;
